import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import FaqView from "@components/views/Help/Faq";
import { getFaqArticles } from "@utils/call-api/help-call";

function Faq({ faqArticles }) {
  return (
    <>
      <CanonicalUrl />

      <FaqView faqArticles={faqArticles} />
    </>
  );
}

export async function getServerSideProps({ locale }) {
  const faqArticles = await getFaqArticles(locale);

  return {
    props: {
      faqArticles,
      ...(await serverSideTranslations(locale, ["common", "help", "accounts"])),
    },
  };
}

Faq.requireAuth = false;

export default Faq;
